// src/ApiService/blogApiService.ts

import BaseApiService from "./baseService";

class GlossaryApiService extends BaseApiService {
  constructor() {
    super("doInsights");
  }

  // listing
  listing(param: object) {
    return this.post("glossary-listing", param);
  }

  // create
  create(param: object) {
    return this.post("glossary-create", param);
  }

  // update
  update(param: object) {
    return this.put("glossary-update", param);
  }

  // details
  details(param: object) {
    return this.post("glossary-details", param);
  }

  // archive
  archive(param: object) {
    return this.post("glossary-archive", param);
  }

  // upload blog image
  // uploadImage(param: FormData) {
  //   return this.postFileUpload("upload-blog-image", param);
  // }
}

const glossaryServiceObj = new GlossaryApiService();
export default glossaryServiceObj;